module.exports = __webpack_public_path__ + "static/media/not-found.d941de6c.svg";